module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "imagec"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18"
    }
  }, [_c('img', {
    staticClass: "in18",
    attrs: {
      "alt": "image",
      "src": "images/ch02.gif"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "h2c"
  }, [_vm._v("Chapter Two:")]), _vm._v(" "), _c('h2', {
    staticClass: "h2d"
  }, [_vm._v("HOMEMADE BASICS")]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_vm._v("Starting a low-carb diet often means giving up your favorite comfort foods—especially baked or starchy items like tortillas and buns. That’s why I decided to create healthy, low-carb alternatives to some of these popular foods. In this chapter, you’ll learn how to make delicious, satisfying breads, buns, pancakes, and tortillas that can be enjoyed on their own, or combined with other sweet or savory ingredients to make a meal. Plus, you’ll find out how to make homemade versions of common condiments—healthy versions of the “stealth” ingredients that can ruin a low-carb diet. Making your own mayonnaise, ketchup, or mustard will help you avoid the unhealthy sugar and additives that often turn up in popular products. (And they taste better than the store-bought, stuff, too!)")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe1"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19"
    }
  }, [_vm._v("ULTIMATE KETO BREAD")])])]), _c('a', {
    attrs: {
      "id": "recipe1"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("My Ultimate Keto Bread is one of the best low-carb breads you’ll ever try. It’s high in heart-healthy monounsaturated fats, and it’s lovely topped with grass-fed butter!")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 LOAF/12 SLICES")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 1 HOUR 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Dry Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5.3 ounces (150 g) macadamia nuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (30 g/1.1 oz) coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (50 g/1.8 oz) whey protein or pastured egg white protein powder, unflavored")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (80 g/2.8 oz) psyllium husk powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Wet Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 large pastured eggs, whole")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 large pastured egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (240 ml/8 fl oz) water, room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 8.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 6.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 1.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 7.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 11.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 143 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (6%), protein (21%), fat (73%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Preheat the oven to 350°F (175°C, or gas mark 4). Line a large loaf pan (about 7 × 4 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" inches/18 × 12 cm) with parchment paper or use a silicone loaf pan. Grind the macadamia nuts using an electric or manual nut grinder. (If you don’t have macadamia nuts, use an equal amount of almond flour and add an extra "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup [60 ml/2 fl oz] of water to the wet ingredients.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mix all the dry ingredients apart from the cream of tartar in a medium bowl. (Do not use whole psyllium husks; if you can’t find psyllium husk powder, process the husks in a blender or coffee grinder until finely ground.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Crack the eggs and place the egg whites and egg yolks into separate bowls. Mix the egg yolks with the water until well combined. Beat all six egg whites until they create soft (not too firm) peaks. Add the cream of tartar throughout the whisking process.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Add the dry ingredients to the egg yolk mixture. Add the whisked egg whites and mix well: you don’t need to be too gentle, but try not to deflate them completely. Whisked egg whites incorporate better than whole whites.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Transfer the dough into the parchment paper-lined loaf pan. Place in the oven and bake for about 60 minutes. To test for doneness, insert a long wooden skewer into the bread. If there are no crumbs on it and it comes out clean, the bread is done. If you’re using a regular loaf pan with parchment paper, remove the loaf from the pan by pulling on the parchment paper: this will help prevent excess moisture from accumulating on the outside of the loaf. Let cool before slicing. Store covered with a kitchen towel for up to 3 days or freeze in an airtight container for longer.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0020-01.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe1"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe2"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" FLUFFY GRAIN-FREE SUNFLOWER BREAD")])])]), _c('a', {
    attrs: {
      "id": "recipe2"
    }
  }), _c('p', {
    staticClass: "centerf"
  }, [_c('a', {
    attrs: {
      "id": "recipe2"
    }
  }, [_vm._v("Wonderfully fluffy and light, this Sunflower Bread is great with nut butter, cream cheese, butter, or my Spiced Berry Jam (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#recipe16"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 LOAF/12 SLICES")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 1 HOUR 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21"
    }
  }, [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Wet Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 large pastured eggs, whole")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 large pastured egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 ml/1 fl oz) toasted sesame oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 g/1.1 oz) ghee or butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml/4 fl oz) water, at room temperature")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("DRY INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (40 g/1.4 oz) flax meal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (80 g/2.8 oz) psyllium husk powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (7 g/0.2 oz) caraway seeds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (70 g/2.5 oz) sunflower seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SLICE")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 6.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 1.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 4.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 10.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 124 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (5%), protein (16%), fat (79%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Preheat the oven to 350°F (175°C, or gas mark 4). Line a large loaf pan (about 7 × 4.5 inch/18 × 12 cm) with parchment paper or use a silicone loaf pan. Working with the wet ingredients first, separate the egg yolks from the egg whites. Set the egg whites aside in a bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mix the egg yolks with the toasted sesame oil and melted ghee or butter. Pour the water into the egg yolk mixture and combine well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("In a separate bowl, mix the flax meal, psyllium husk powder, baking soda, caraway seeds, and salt. (Do not use whole psyllium husks; if you can’t find psyllium husk powder, process the husks in a blender or coffee grinder until finely ground.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Beat the egg whites until they create soft peaks. Add the cream of tartar while beating; this helps the egg whites stay fluffy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Using an electric mixer, add the egg yolk mixture to the bowl with the dry ingredients and process well. Slowly add the whisked egg whites: you don’t need to be too gentle, but try not to deflate them completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Fold the sunflower seeds into the batter. Fill the loaf pan with the batter and transfer to the oven. Bake for about 60 minutes. To test for doneness, insert a long wooden skewer into the bread. If there are no crumbs on it and it comes out clean, the bread is done.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("If you’re using a regular loaf pan with parchment paper, remove the loaf from the pan by pulling on the parchment paper: this will help prevent excess moisture from accumulating on the outside of the loaf. Let the loaf cool on a tray for at least 15 to 20 minutes. Store at room temperature covered with a kitchen towel for up to three days or place in a zip-top bag and freeze for longer.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIPS")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Make sure you follow the recipe step by step. Even a small change can result in a lumpy texture or a batter that’s too moist. If you don’t add the water into the egg yolks and do so separately after you mix in the egg yolks, the texture will become lumpy and rubbery.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• If your bread turns out to be a vibrant green color, don’t panic—it’s perfectly safe. Sunflower seeds contain chlorogenic acid, an antioxidant that gives the seeds the ability to turn green when mixed with alkaline baking ingredients like baking soda.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22"
    }
  }, [_vm._v("LOW-CARB SOURDOUGH BREAD")])]), _vm._v(" "), _c('p', {
    staticClass: "centerf"
  }, [_vm._v("It took me weeks of fine-tuning to come up with the perfect recipe for a low-carb sourdough bread, but all my hard work paid off! It’s not as crispy as regular sourdough, but toasting it before serving makes it absolutely delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 LOAF/12 SLICES")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 1 HOUR 30 MINUTES "), _c('span', {
    staticClass: "small"
  }, [_vm._v("+ CULTURING")])]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Culturing Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("10.6 ounces (300 g) macadamia nuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml/4 fl oz) water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("As many probiotic capsules as you need to get 30 to 40 billion live probiotic cultures (about 16 capsules)")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Dry Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (80 g/2.8 oz) psyllium husk powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (75 g/2.6 oz) almond flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (30g/1.1 oz) coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Wet Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 large pastured eggs, whole")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 large pastured egg white")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml/4 fl oz) water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23"
    }
  }, [_vm._v("NUTRITION FACTS PER SLICE")])]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 11.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 8.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 3.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 6.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 24.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 264 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (5%), protein (10%), fat (85%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Put the macadamias and water into a blender. Pulse until very smooth. The mixture should be quite thick; do not add more water. (If you don’t have macadamia nuts, use the same amount of ground blanched almonds.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Pour the blended nuts into a bowl. Open each probiotic capsule one by one and add the powder from each to the bowl. Mix until well combined. I like my bread sour, so I used 16 capsules with 2.5 billion live cultures in each. The more capsules you use, the more sour the dough will be.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Set a plate on top of the bowl and transfer to the oven. Turn the oven light on. This should be enough to slowly bring the temperature to 105 to 110°F (40 to 45°C)—the perfect conditions for culturing the macadamia nuts. Don’t turn the oven on if you don’t have to; just use the light. If the temperature is too high, it will kill the bacteria and it won’t culture: if the temperature is too low, it will culture slowly or not at all. Alternatively, you can also use a food dehydrator or a yogurt maker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("After 12 to 24 hours (the longer you leave it, the more sour the dough will be), remove the dough from the oven. Preheat the oven to 350°F (175°C, or gas mark 4). Line a large loaf pan (about 7 × 4.5 inch/18 × 12 cm) with parchment paper or use a silicone loaf pan.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Combine the psyllium husk powder, almond flour, coconut flour, baking soda, and salt in a separate bowl and mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Separate all the egg yolks from the egg whites and place in two bowls. (You will need a total of 4 mixing bowls for this recipe: one for the egg yolks, one for egg whites, one for the dry mixture, and one for the macadamia nut mixture.) Set one egg yolk aside; you will brush the top of the bread with it. You’ll have one egg yolk left over, which you can use in another recipe. Add the remaining water to the bowl with the 4 egg yolks and mix well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Beat the egg whites until they create soft peaks, gradually adding the cream of tartar throughout the process. When done, set it aside. Pour the egg yolk mixture into the dry mixture and combine well (an electric blender is ideal).")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Add the cultured macadamia nut dough and process well. Add the whisked egg whites and mix until well combined. You don’t need to be too gentle but try not to deflate the whites completely; use a slow blending option.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Transfer the dough into the pan lined with parchment paper or use a silicone loaf pan. Brush the top of the dough with the reserved egg yolk. (If the egg yolk is too thick or dry, mix it with a teaspoon of water.) This egg wash will give your bread a crispy, golden finish. Bake for about 60 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("When done, the top should be rounded and golden in color. (Note: If you use a pan that’s too large, you may not get a rounded top.) Store at room temperature covered with a kitchen towel for up to three days or place in a zip-top bag and freeze for longer.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Make sure you follow this recipe step by step: even a small change can result in failure. Here’s one of my most memorable failed experiments: When I cultured all the ingredients together (macadamia nuts, almond flour, coconut flour, and psyllium) instead of adding the dry ingredients just before baking, the bread looked unappetizing and had a jelly texture. (Yuck!) Also, be careful not to use extra water. If you do, the dough will be too moist and won’t rise properly.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe3"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24"
    }
  }, [_vm._v("ESSENTIAL KETO CREPES")])])]), _c('a', {
    attrs: {
      "id": "recipe3"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("They feel festive and fancy, but crepes are so quick and easy—and they can be either savory or sweet, depending on your mood. You can also use them in place of tortillas or wraps.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 4 SERVINGS")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 large eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 large egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (24 g/0.8 oz) coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (8 g/0.3 oz) psyllium husk powder or ground chia seeds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup plus 2 tablespoons (90 ml/3 fl oz) coconut milk, cream or almond milk")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon gluten-free baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 g/1.1 oz) ghee or coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons garlic powder or onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt to taste")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 5.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 2.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 2.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 10.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 19.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 239 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (5%), protein (18%), fat (77%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Separate the egg whites from the egg yolks. You will only need 2 egg yolks and 8 egg whites, as the crepes hold better together when more egg whites are used. Reserve any remaining egg yolks for use in another recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Place the whole eggs and egg whites, coconut flour, psyllium husk powder or chia seeds, coconut milk, baking soda, and cream of tartar in a bowl and mix well. (You can use heavy whipping cream or almond milk in place of the coconut milk, if you like: these have less carbs and fat.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Add the garlic powder and whisk well. Alternatively, to make sweet crepes, use a few drops of stevia or 2 tablespoons (20 g) of erythritol in place of the garlic powder.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Let the batter sit for 5 to 10 minutes so the coconut flour and psyllium have time to soak up the moisture. Then whisk again. Add water if the mixture is too thick. (If you can’t find psyllium husk powder, process the husks in a blender or coffee grinder until finely ground.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Heat a nonstick pan evenly greased with ghee over a medium heat. Move the pan while pouring the batter in to ensure that the mixture covers the bottom of the pan in a thin layer. The batter should be runny so that you can spread it easily. If it’s too thick, add a tablespoon (15 ml/0.5 fl oz) of water. Make the crepes one by one, greasing the pan in between with a small amount of oil to avoid sticking. Depending on the size of the crepes, you will get two large or four medium crepes per recipe. Use as wraps for meat and vegetables. Let cool and then store in an airtight container in the fridge for up to 5 days.")])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe3"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe4"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25"
    }
  }, [_vm._v("GRAIN-FREE TORTILLAS")])])]), _c('a', {
    attrs: {
      "id": "recipe4"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Tortillas can easily be made crispy or soft, depending on cooking time. Wrap these beauties around some meat and vegetables and add dressing for a satisfying meal.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 10 SERVINGS")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 20 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 1 HOUR")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Dry Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (100 g/3.5 oz) almond flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (110 g/4 oz) flax meal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (30 g/1.1 oz) coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (8 g/0.3 oz) psyllium husks, whole")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (16 g/0.6 oz) chia seeds, ground")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon garlic powder or onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Wet Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (240 ml/8 fl oz) lukewarm water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 g/1.1 oz) lard or ghee")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 7.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 5.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 1.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 13.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 165 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (5%), protein (13%), fat (82%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Combine all the dry ingredients in a bowl and pour in one cup (240 ml/8 fl oz) of water. (If the dough is too dry to roll, add a few more tablespoons [45 to 60 ml/1.5 to 2 fl oz] of water. If you use too much, the dough will get too sticky and will become difficult to roll.) Mix well using your hands and shape into an oval. Let the dough rest in the fridge for up to an hour.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("When ready, remove the dough from the fridge and cut it into six equal pieces. (You will use the excess dough after cutting the tortillas, in the next step, to make the remaining four tortillas.) Place a piece of the dough between two pieces of parchment paper and roll it out until very thin. Alternatively, use a silicone roller and a silicone mat.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remove the top parchment paper and press a large 8-inch (20 cm) lid into the dough (or use a piece of parchment paper cut into a round shape: just trace around it with your knife) to cut out the tortilla.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Repeat for the remaining pieces of dough. Add the cut-off excess dough to the last piece and create the remaining 4 tortillas from it. If you have any dough left over, simply roll it out and cut it into tortilla-chip shapes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Grease a large pan with the ghee or lard and cook one tortilla at a time for 2 to 3 minutes on each side over a medium heat until lightly browned. Don’t overcook it: it’ll become too crispy. Once cool, store the tortillas in an airtight container for up to a week and reheat them in a dry pan if needed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt1"
  }, [_vm._v("(Note: Make sure you use whole psyllium husks in this recipe. Unlike other bread recipes in this book, this one doesn’t use psyllium husk powder: whole husks make the tortillas more compact and flexible.)")])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe4"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe5"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26"
    }
  }, [_vm._v("ULTIMATE KETO BUNS")])])]), _c('a', {
    attrs: {
      "id": "recipe5"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Are you missing “regular” bread? Never fear: these are the best low-carb buns you can imagine. They’re nice and fluffy, and they taste just like the real thing!")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 10 SERVINGS")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 1 HOUR")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Dry Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cups (150 g/5.3 oz) almond flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" cup (40 g/2.8 oz) psyllium husk powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (60 g/2.1 oz) coconut flour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (75 g/2.7 oz) flax meal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon baking soda")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons cream of tartar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 tablespoons (40 g/1.4 oz) sesame seeds (or poppy, sunflower, or caraway seeds)")]), _vm._v(" "), _c('p', {
    staticClass: "itemhead"
  }, [_vm._v("Wet Ingredients")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("6 large pastured egg whites")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 large pastured eggs")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cups (470 ml/16 fl oz) boiling water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27"
    }
  }, [_vm._v("NUTRITION FACTS PER SLICE")])]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 12.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 8.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 4.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 10.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 15.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 208 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (9%), protein (21%), fat (70%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Preheat the oven to 350°F (175°C, or gas mark 4). Mix all the dry ingredients except the sesame seeds in a bowl. (Do not use whole psyllium husks; if you can’t find psyllium husk powder, process the husks in a blender or coffee grinder until finely ground.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mix the eggs and egg whites in a separate bowl. Add the egg mixture to the dry ingredients and add the boiling water. Process well in a mixer until the dough is thick.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Using a spoon, form the dough into buns of equal sizes and place them on a nonstick baking sheet or a baking sheet lined with parchment paper (you could even use small tart trays). The buns will grow as they bake, so make sure to leave some space between each.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Top each of the buns with a sprinkling of sesame seeds and press the seeds into the dough so they won’t fall out. Transfer the buns to the oven and bake for about 45 minutes.")])]), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "recipe5"
    }
  }, [_vm._v("Remove from the oven, let the tray cool, and then transfer the buns to a rack until they cool to room temperature. Store at room temperature if you plan to use the buns in the next couple of days or freeze for future use. Try them alongside your favorite salad, or use them as buns for my Ultimate GuacBurger (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07#recipe26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v("). You can also shape them into bagels to make Healthy Salmon Bagels ("), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05#recipe21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIPS")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Psyllium absorbs lots of water. When you’re baking with psyllium, remember to drink enough water throughout the day to prevent constipation!")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• To speed things up, you can mix all the dry ingredients ahead of time and store them in a zip-top bag. Label the bag with the number of servings. When you’re ready to bake, just add the wet ingredients.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Make sure you weigh all the ingredients using scales. Even small differences can affect the final result of this recipe.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• If your buns appear to have large hollow bubbles inside them, it may be due to the psyllium. Again, make sure you use powder, not whole husks.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• If your buns don’t rise properly, try the recipe again using only egg whites and omit the egg yolks altogether.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• If the final result is too moist, do not reduce the water used in this recipe—if you do, the psyllium will clump. Instead, dry the buns in the oven on low, up to 210°F (100°C), for 30 to 60 minutes. If necessary, cut them in half and place in a toaster.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Don’t let the batter sit for too long: put the buns in the oven as soon as you’ve formed them.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Most of the above tips apply to any recipes using psyllium husk powder.")]), _vm._v(" "), _c('p', {
    staticClass: "ulista"
  }, [_vm._v("• Cream of tartar and baking soda act as leavening agents. This is how it works: To get 2 teaspoons of gluten-free baking powder, combine "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon of baking soda with 1 teaspoon of cream of tartar.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe6"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28"
    }
  }, [_vm._v("MAYONNAISE")])])]), _c('a', {
    attrs: {
      "id": "recipe6"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Mayonnaise is a fantastic keto-friendly condiment. To ensure best results, be sure to set any refrigerated ingredients out on your countertop to let them reach room temperature before you begin.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" ABOUT 1 CUP (240 G)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 pastured egg yolk")])]), _c('p', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "id": "recipe6"
    }
  }, [_vm._v("1 teaspoon Dijon Mustard (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#recipe9"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (180 ml/6 fl oz) mild olive oil (or macadamia, avocado, or walnut oil)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15 ml/0.5 fl oz) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15 ml/0.5 fl oz) apple cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Optional: 3 to 5 drops liquid stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon garlic powder or onion powder")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (1 tablespoon/15 g)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 0.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 0.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 12.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 111 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (0 %), protein (1 %), fat (99 %)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("When all ingredients have reached room temperature, separate the egg white from the egg yolk. (Reserve the egg white for another recipe.) Place the yolk and Dijon mustard into a bowl. Blend until well combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Using a food processor or hand whisk to mix as you go, start to drizzle in the oil very slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Keep drizzling in the oil until the mixture starts to look more like the consistency of mayonnaise. Steadily pour the oil in until all of it is incorporated. Keep mixing until the mayo reaches the desired thickness. If it doesn’t seem thick enough, add a bit more oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Add the lemon juice and vinegar—which will turn the color a light yellow—then season with salt. If it is too tart, add a few drops of liquid stevia and mix well. If you think the consistency is too thick, add a few drops of water. To boost the flavor, add a teaspoon of garlic or onion powder and mix until well combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Transfer the mayonnaise to a glass container and seal well. You can store it in the fridge for up to a week. If you want the mayonnaise to last several months, add a tablespoon or two (15 to 30 g/0.5 to 1 oz) of whey.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("When using raw eggs: Due to the slight risk of "), _c('em', [_vm._v("Salmonella")]), _vm._v(" and other foodborne illnesses, you should use only fresh, clean, properly-refrigerated grade A or AA eggs with intact shells. Avoid contact between the yolks or whites and the shell. Prevent any risks by using eggs with pasteurized shells.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0029-01.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe7"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" KETCHUP")])])]), _c('a', {
    attrs: {
      "id": "recipe7"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Store-bought products often contain added sugar and preservatives. But that doesn’t mean you have to do away with your favorite condiments. You’ll be surprised at how easy it is to make ketchup at home!")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" ABOUT 1 CUP (240 G)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 small (60 g/2.1 oz) white onion, peeled and cut into small pieces")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves garlic, peeled and chopped")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (240 g/8.5 oz) tomato puree, unsweetened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) apple cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v(" teaspoon allspice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v(" teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 to 6 drops liquid stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (20 g/0.7 oz) erythritol or Swerve")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Freshly ground black pepper to taste")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) water")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (1 tablespoon/15 g)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 0.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 0 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 4.8 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (77%), protein (7%), fat (6%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Combine all the ingredients in a small saucepan and simmer, covered, over low heat for 5 to 10 minutes. Add a splash of water if the mixture seems too thick. When done, transfer the mixture to a blender and pulse until smooth. Pour the ketchup into a glass jar and store in the fridge for up to a month.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")])]), _c('p', {
    staticClass: "noindentt"
  }, [_c('a', {
    attrs: {
      "id": "recipe7"
    }
  }, [_vm._v("Homemade ketchup is a key ingredient in many other sauces, dressings, and dips, like my Spicy Chocolate BBQ Sauce (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#recipe12"
    }
  }, [_vm._v("here")]), _vm._v(")!")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe8"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30"
    }
  }, [_vm._v("BONE BROTH")])])]), _c('a', {
    attrs: {
      "id": "recipe8"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Drinking bone broth is one of the best ways to replenish electrolytes (sodium, magnesium, and potassium) and to eliminate the symptoms of keto-flu.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" ABOUT 6 TO 8 CUPS (1.4 TO 1.9 L/47.3 TO 64.2 FL OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 2 HOURS OR MORE")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 medium (120 g/4.2 oz) carrots")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 medium (90 g/3.2 oz) parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 medium (100 g/3.5 oz) white onion, peeled and halved")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 (80 g/2.8 oz) celery stalks")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3.3 pounds (1.5 kg) oxtail or assorted bones (chicken feet, marrowbones, etc.)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 ml/1 fl oz) apple cider vinegar or lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 to 3 bay leaves")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (18 g/0.6 oz) pink Himalayan or sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("8 to 10 cups (1.9 to 2.4 L/64 to 81 fl oz) water (enough to cover the bones, no more than "), _c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" the capacity of the pressure cooker, "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" the capacity of your Dutch oven, or "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" the capacity of your slow cooker)")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (1 cup/235 ml/8 fl oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 0.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 0.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 3.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 72 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (4%), protein (20%), fat (76%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Peel the carrots and parsnips and cut them into thirds. Halve the onion and peel and halve the garlic cloves. Keep the onion skin on to help the broth get a nice golden color. Wash and cut the celery into thirds. Place all of the ingredients into the pressure cooker or slow cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("In the pressure cooker:")]), _vm._v(" Lock the lid of your pressure cooker and turn it to high pressure/high heat. Once it reaches high pressure, turn it to the lowest heat and set the timer on the pressure cooker for 90 minutes. When done, take the pot off the heat and let the pressure release naturally for about 10 to 15 minutes before opening the lid. Pour the broth through a strainer into a large dish. Discard the vegetables and set the meaty bones aside to cool down. When the bones are chilled, shred the meat off with a fork. If there is any gelatin left on the bones, you can reuse them for another batch of Bone Broth: just store them in the freezer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("In the Dutch oven or slow cooker:")]), _vm._v(" Cover with a lid and cook for at least 6 hours on high or up to 48 hours on low. If you opt for longer cooking time, you’ll have to remove the oxtail using tongs, shred the meat off using a fork, and then place the bones back into the pot.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Use the broth immediately or put it in the fridge overnight, where it will become partially jellied. Oxtail is high in fat, and the greasy layer on top—the tallow—will solidify. Simply scrape most of the tallow off and discard or reuse it for cooking. Keep the broth in the fridge if you’re planning to use it over the next five days. For future uses, store it in small containers and freeze.")])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe8"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe9"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31"
    }
  }, [_vm._v("DIJON MUSTARD")])])]), _c('a', {
    attrs: {
      "id": "recipe9"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Making mustard at home is so simple—and so rewarding. It takes just a few minutes to prepare, and it tastes amazing after a few weeks of aging in the fridge.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" ABOUT 2 CUPS (480 G/16.9 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 15 TO 20 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 medium (110 g/3.9 oz) onion")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (240 ml/8 fl oz) dry white wine")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) white wine vinegar; or substitute with "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) vinegar and "), _c('span', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (180 ml/6 fl oz) of water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml/4 fl oz) water")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (120 g/4.2 oz) mustard powder/ground mustard seeds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon ground turmeric")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("3 to 5 dashes Tabasco or other sugar-free hot sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 to 10 drops liquid stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 ml/1 fl oz) extra virgin olive oil (or macadamia, or avocado oil)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (1 tablespoon/15 g/0.5 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 1.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 0.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 1.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 27 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (13%), protein (15%), fat (72%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Peel and roughly chop the onion and garlic and place them in a nonreactive saucepan below). Pour in the wine, vinegar, and water and bring to a boil over medium heat. Simmer for about 5 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Cool and strain the mixture, discarding the solids. Place the mustard powder into a saucepan and add the strained liquid. Mix until well combined. Cook over low-medium heat until it thickens, about 2 to 5 minutes. Add the turmeric, Tabasco, stevia, oil, and salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Mix until well combined. Store in a jar in the refrigerator for up to 6 months. The mustard will taste best after a few weeks of aging.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("You can make different types of mustard by adding a variety of optional ingredients. Try horseradish, fresh herbs, or whole grain mustard seeds.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("WHAT IS A NONREACTIVE SAUCEPAN?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s a saucepan made of a material that will not react with acidic ingredients. For example, stainless steel is nonreactive, while copper is a reactive material that will easily wear off if used with acidic ingredients like lemon juice or vinegar.")])]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0032-01.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe9"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe10"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" HOLLANDAISE SAUCE")])])]), _c('a', {
    attrs: {
      "id": "recipe10"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Hollandaise sauce is easy. It’s also the best way to add healthy fats to your diet and use up leftover egg yolks.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 SERVING")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 g/1.1 oz) butter")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 large pastured egg yolk")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" to 1 tablespoon (7.5 to 15 ml/0.25 to 0.5 fl oz) water, plus 1 cup (235 ml/8 fl oz) for steaming")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15 ml/0.5 fl oz) lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon Dijon mustard")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Pinch of salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 1.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 1.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 3.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 29 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 274 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (2%), protein (4%), fat (94%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Gently melt the butter and set aside; it should be warm, but not too hot. Mix the egg yolk with "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" to 1 tablespoon (7.5 to 15 ml/0.25 to 0.5 fl oz) of water, plus the lemon juice, Dijon mustard, and salt. Add the remaining water to a medium saucepan and bring to a boil. Keep it on medium heat. Place the bowl with the egg yolk mixture on top of the saucepan and stir continually. (For this to work, the bowl must be bigger than the saucepan, and the boiling water shouldn’t reach the bottom of the bowl; only the steam heats the bowl.) Keep mixing until the mixture starts to thicken: then, very slowly, pour in the melted butter until it becomes thick and creamy. Stir constantly to avoid clumping. If the Hollandaise is too thick, add a splash of water. Serve immediately over poached eggs or baked salmon. Do not reheat the Hollandaise: it will clump. If you’re making it only for yourself, prepare a single serving at a time.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0033-01.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe10"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe11"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" MARINARA SAUCE")])])]), _c('a', {
    attrs: {
      "id": "recipe11"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("This easy sauce can be used for pizza topping, with zucchini noodles, as a dip with fresh vegetables, or on low-carb bread.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 2 CUPS (490 G/17.3 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (150 g/5.3 oz) cherry tomatoes")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (20 g/0.7 oz) fresh basil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 small (30 g/1.1 oz) shallot")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 tablespoons (60 g/2.2 oz) tomato puree")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) extra virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Freshly ground pepper")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING ("), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" CUP/60 G/2.1 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 3.5 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 2.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 9.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 101 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (10%), protein (3%), fat (87%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Wash and drain the tomatoes and basil. Peel the garlic and shallot. Add all the ingredients to a food processor and process until smooth. If you prefer a chunky texture, leave some tomatoes and basil aside to dice and add to the smooth sauce after it’s blended. When done, store in an airtight container in the fridge for up to a week.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0034-01.jpg"
    }
  })])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe11"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe12"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" SPICY CHOCOLATE BBQ SAUCE")])])]), _c('a', {
    attrs: {
      "id": "recipe12"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Are you bored with regular BBQ sauce? Try this sweet-and-spicy version, which can be used as a meat marinade or as a dip to accompany Zucchini Fries Sides).")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" CUPS (375 G/13.2 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cloves garlic")])]), _c('p', {
    staticClass: "item"
  }, [_c('a', {
    attrs: {
      "id": "recipe12"
    }
  }, [_vm._v("1 cup (240 g/8.5 oz) Ketchup (")]), _c('a', {
    attrs: {
      "href": "#/xhtml/ch02#recipe7"
    }
  }, [_vm._v("here")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 ml/1 fl oz) apple cider vinegar")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 ml/1 fl oz) coconut aminos or fish sauce")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (10 g/0.4 oz) unsweetened cacao powder")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (20 g/0.7 oz) erythritol or Swerve")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("5 to 10 drops stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 teaspoons paprika (regular or smoked)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon chile powder (mild or hot, to taste)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (30 g/1.1 oz) butter or ghee")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon smoked salt or regular sea salt")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (1 tablespoon/15 g)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 1.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 0.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 0.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 1.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 15 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (24%), protein (8%), fat (68%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Peel and crush the garlic. Place all the ingredients in a saucepan and cook over medium heat for 5 to 10 minutes. Transfer to a glass jar and keep in the fridge for up to a month.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Coconut aminos are a healthier alternative to soy sauce and are often recommended as a healthy soy sauce substitute on paleo diets. Soy products should be eaten in moderation, and some of them should be avoided completely. Unfortunately, most soy products come from genetically-modified (GMO) soybeans, and how GMO products affect health is still unclear. If you decide to use soy products, find ones that are made from non-GMO, fermented, unprocessed soy and that are gluten-free.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe13"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35"
    }
  }, [_vm._v("PESTO, THREE WAYS")])])]), _c('a', {
    attrs: {
      "id": "recipe13"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Making your pesto at home is an easy way to add flavor and healthy fats to your diet, minus the additives that are often found in store-bought versions.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "num"
  }, [_vm._v("2")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("3")]), _vm._v(" CUPS (160 G/5.6 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (50 g/1.8 oz) pecans or walnuts, soaked for at least 1 hour")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cups (30 g/1.1 oz) basil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cups (20 g/0.7 oz) arugula")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("4 cloves garlic")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 teaspoon fresh lemon zest")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15 ml/0.5 fl oz) freshly squeezed lemon juice")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) extra virgin olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Salt and freshly ground black pepper, to taste")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Optional: "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (45 g/1.6 oz) grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (2 tablespoons/30 g/1.1 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 2.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 1.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 1.1 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 15 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 141 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (3%), protein (3%), fat (94%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Drain the nuts and discard the water. Wash the basil and arugula. Place all the ingredients into a blender and pulse until smooth. Transfer to a jar and refrigerate. You can keep your pesto in the fridge for up to a week or two if it’s stored properly: it helps to pour a thin layer of olive oil on the top, as it keeps it fresh for longer. Whenever you use the pesto, remember to add another thin layer of olive oil before you put it back in the fridge.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("VARIATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are limitless varieties of pesto: simply combine your favorite herbs, nuts, seeds, herbs, and spices. (If you have a nut allergy, use sunflower seeds instead.) Try these variations:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Spinach Pesto:")]), _vm._v(" Place 2 cups (60 g/2.1 oz) spinach, "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (65 g/2.3 oz) soaked macadamia nuts, (68 g/2.4 oz) pine nuts, or (75 g/2.7 oz) almonds, 4 cloves garlic, 2 spring onions, "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" cup (60 ml/2 fl oz) olive oil, salt and freshly ground black pepper, to taste, and "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (45 g/1.6 oz) Parmesan cheese (optional) into a blender and pulse until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('strong', [_vm._v("Red Pesto:")]), _vm._v(" Place 1 cup (15 g/0.5 oz) basil, "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (65 g/2.3 oz) soaked macadamia nuts, "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (28 g/1 oz) sundried tomatoes, 2 tablespoons (30 g/1.1 oz) tomato puree, 1 tablespoon (15 ml/0.5 fl oz) freshly squeezed lemon juice, 2 cloves of garlic, and "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (45 g/1.6 oz) Parmesan cheese (optional) into a blender and pulse until smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "tiphead"
  }, [_vm._v("TIP")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("If you can, use soaked and dehydrated nuts. If you want to preserve homemade pesto for longer, freeze it in manageable portions by spooning it into an ice cube tray. It’ll keep in the freezer for up to 6 months. When you need it, just set the required amount in a bowl to thaw at room temperature until it melts.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0036-01.jpg"
    }
  })])])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe13"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe14"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" CAULI-RICE")])])]), _c('a', {
    attrs: {
      "id": "recipe14"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Not only is cauliflower a perfect replacement for potatoes and rice, it’s also ideal for thickening sauces without adding extra carbs and for making pizza bases. If you’re following a healthy, low-carb diet, you should always have some Cauli-Rice on hand.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 5 CUPS (600 G/21.2 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 10 TO 15 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 head cauliflower (600 g/21.2 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER CUP (120 G/4.2 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 2.4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 3.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 2.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Fat: 0.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 30 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (54%), protein (35%), fat (11%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remove the leaves and the hard core of the cauliflower and cut it into florets. Wash the cauliflower florets thoroughly and drain well. Once dry, run them through a hand grater or food processor with a regular blade or a grating blade; the latter will make the cauliflower look more like rice. Pulse until the florets resemble grains of rice. (Don’t overdo it—it takes only a few more seconds to turn your Cauli-Rice into cauli-puree!) Refrigerate in an airtight container for up to four days. Cook your Cauli-Rice using these methods:")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Steaming:")]), _vm._v(" Place in a steam pot with boiling water and cook for 5 to 7 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Microwaving:")]), _vm._v(" Transfer the processed cauliflower into a microwave-safe bowl and cook in the microwave on medium-high for 5 to 7 minutes. You won’t need any water with this method.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Pan roasting:")]), _vm._v(" Briefly cook the cauli-rice in a pan greased with butter or ghee or add it directly to the pot with whatever meat or sauce you plan to serve it with. This method adds extra flavor.")]), _vm._v(" "), _c('p', {
    staticClass: "ulist"
  }, [_vm._v("• "), _c('strong', [_vm._v("Baking:")]), _vm._v(" Preheat the oven to 400°F (200°C, or gas mark 6). Spread the grated cauli-rice over a baking sheet lined with parchment paper and cook for 12 to 15 minutes, flipping two or three times. This method is useful when you want the cauli-rice to be as dry as possible.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_38"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0038-01.jpg"
    }
  })])])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe14"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe15"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_39"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" TOASTED NUT BUTTER")])])]), _c('a', {
    attrs: {
      "id": "recipe15"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("High in healthy monounsaturated fats, macadamia nuts are essential to the KetoDiet—and what’s more, they’re delicious in this easy-to-prepare nut butter.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 1 "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" CUPS (400 G/14.1 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 25 TO 35 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (130 g/4.6 oz) macadamia nuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (150 g/5.3 oz) almonds, blanched")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 cups (120 g/4.2 oz) desiccated coconut, flaked")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (2 tablespoons/32 g/1.1 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 5.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 3.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 2.3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 4 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 20.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 206 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (4%), protein (8%), fat (88%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Preheat the oven to 350°F (175°C, or gas mark 4). Spread the nuts and flaked coconut evenly over a baking sheet and transfer to the oven. Bake for 12 to 15 minutes until slightly brown. Keep an eye on the nuts; if they burn, they will have an unpleasant bitter taste.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remove from the oven and let cool for 10 minutes. Place the cooled nuts and coconut in a food processor and pulse until smooth and creamy. At first, the mixture will be dry. Scrape down the sides of your processor several times with a rubber spatula if the mixture sticks. This process may take up to 10 minutes depending on your processor.")])]), _c('p', {
    staticClass: "noindenta"
  }, [_c('a', {
    attrs: {
      "id": "recipe15"
    }
  }, [_vm._v("Spoon the butter into a glass container and keep refrigerated or at room temperature. Try adding a tablespoon (15 g/0.5 oz) of it to a smoothie or use it to thicken sauces or make cookies Chocolate Chip & Orange Cookies, ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#recipe38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_41"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0041-01.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe16"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_40"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" SPICED BERRY JAM")])])]), _c('a', {
    attrs: {
      "id": "recipe16"
    }
  }, [_c('p', {
    staticClass: "centerf"
  }, [_vm._v("Pair this sugar-free berry jam with full-fat yogurt, or use it as a secret weapon when you’re creating luscious low-carb desserts. You can use any berries you like: either fresh or frozen will work just fine.")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 2 CUPS (640 G/22.6 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 10 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 20 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (140 g/4.9 oz) strawberries")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (125 g/4.4 oz) raspberries")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (140 g/4.9 oz) blackberries")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (75 g/2.6 oz) blueberries")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon ground ginger or 1 teaspoon freshly grated ginger")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" teaspoon cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (6 g/0.2 oz) orange zest")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v(" teaspoon ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 star anise, ground")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (20 g/0.7 oz) erythritol or Swerve")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("10 to 15 drops liquid stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (16 g/0.5 oz) chia seeds")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (2 tablespoons/40 g/1.4 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 4.8 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 2.2 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 2.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 0.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 0.6 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 24 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (57%), protein (14%), fat (29%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Wash the berries and place in a saucepan. Add all the remaining ingredients except for the chia seeds. Bring to a boil and then lower the heat. Cook for 5 to 8 minutes. Remove from the heat. Remove and discard the star anise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Add the chia seeds and mix well. Let the jam sit for about 15 minutes before transferring to a lidded jar. Store in the fridge for up to two weeks.")]), _vm._v(" "), _c('div', {
    staticClass: "land100r"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_42"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0042-01.jpg"
    }
  })])])]), _c('h3', {
    staticClass: "h3r"
  }, [_c('a', {
    attrs: {
      "id": "recipe16"
    }
  }), _c('a', {
    attrs: {
      "id": "recipe17"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_43"
    }
  }, [_c('span', {
    staticClass: "ent1"
  }, [_vm._v("◁")]), _vm._v(" CHOCOLATE HAZELNUT BUTTER")])])]), _c('a', {
    attrs: {
      "id": "recipe17"
    }
  }), _c('p', {
    staticClass: "centerf"
  }, [_c('a', {
    attrs: {
      "id": "recipe17"
    }
  }, [_vm._v("If you love Nutella, you’re in luck! This is a healthier version of the famous chocolate-hazelnut spread. It’s high in heart-healthy monounsaturated fats, and it’s sugar-free. Slather it on low-carb pancakes and waffles or use it in Chocolate Fat Bombs ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/ch09#recipe36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("here")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "hparaa"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common01.gif"
    }
  }), _vm._v(" 2 CUPS (490 G/17.3 OZ)")]), _vm._v(" "), _c('p', {
    staticClass: "hpara"
  }, [_c('img', {
    staticClass: "in4",
    attrs: {
      "alt": "image",
      "src": "images/common02.gif"
    }
  }), _vm._v(" 5 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "hparab"
  }, [_c('img', {
    staticClass: "in5",
    attrs: {
      "alt": "image",
      "src": "images/common03.gif"
    }
  }), _vm._v(" 25 TO 35 MINS")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("INGREDIENTS")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (150 g/5.3 oz) hazelnuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 cup (130 g/4.6 oz) macadamia nuts")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (75 g/2.6 oz) almonds")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 bar (100 g/3.5 oz) extra-dark chocolate, 85% cacao or more")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (15 g/0.5 oz) extra virgin coconut oil")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 vanilla bean or 1 teaspoon sugar-free vanilla extract")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("1 tablespoon (5 g/0.2 oz) cacao powder, unsweetened")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("2 tablespoons (20 g/0.7 oz) erythritol or Swerve, powdered")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("10 to 15 drops liquid stevia")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("Optional: "), _c('span', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("/"), _c('span', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v(" cup (120 ml/4 fl oz) coconut milk or heavy whipping cream")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_vm._v("NUTRITION FACTS PER SERVING (2 tablespoons/32 g/1.1 oz)")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Total carbs:")]), _vm._v(" 5.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fiber:")]), _vm._v(" 2.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Net carbs:")]), _vm._v(" 3 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Protein:")]), _vm._v(" 3.9 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Fat:")]), _vm._v(" 18.7 g")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Energy:")]), _vm._v(" 193 kcal")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_c('strong', [_vm._v("Macronutrient ratio:")]), _vm._v(" Calories from carbs (6%), protein (8%), fat (86%)")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Preheat the oven to 375°F (190°C, or gas mark 5). Spread the hazelnuts, macadamia nuts, and almonds on a baking sheet and transfer to the oven. Bake for about 10 minutes until lightly browned.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Remove from the oven and let the nuts cool for 15 minutes. Meanwhile, melt the chocolate with the coconut oil in a water bath: Place a bowl over a pot with boiling water and let the chocolate melt, stirring frequently. Make sure the water doesn’t touch the bottom of the bowl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Rub the hazelnuts in your hands to remove the skins: this will help make the butter smooth and avoid the bitter taste imparted by the skins.")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Place the nuts into a food processor and pulse until smooth. Cut the vanilla bean lengthwise and scrape out the seeds. Add the cacao powder, vanilla seeds, powdered erythritol, and liquid stevia to the melted chocolate. (To powder the erythritol, place it in a blender or coffee grinder and pulse until powdery for 15 to 20 seconds.) Pour the chocolate mixture into the nut mixture and pulse until smooth. If you’re using the coconut milk, pour it into the hazelnut mixture and pulse again. Pour into a glass container and store in the fridge for up to 4 weeks.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 72
// module chunks = 0